import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { scrubBreadcrumb, scrubSentryEvent } from "./lib/sentryScrub";

// #46 — baked in at build time by vite.config.ts (tier from the deployed branch, release = commit).
declare const __SENTRY_ENVIRONMENT__: string;
declare const __SENTRY_RELEASE__: string;

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: __SENTRY_ENVIRONMENT__,
  release: __SENTRY_RELEASE__,
  sendDefaultPii: true,
  beforeSend: scrubSentryEvent,
  beforeBreadcrumb: scrubBreadcrumb,
});

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
    <App />
  </Sentry.ErrorBoundary>,
);
